export default __webpack_public_path__ + "static/media/search.d9472558.png";